import styled from 'styled-components';
import TextField from '@mui/material/TextField';

export const PaginationRow = styled.tr`
  position: sticky;
  bottom: 0;
  background: white;

  td {
    padding: 0;
    .MuiTablePagination-toolbar {
      border: none;
    }
  }
`;

export const SecondRowHeader = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey2};

  th {
    text-align: left;

    input {
      margin: 0 auto 0 10px;
    }
  }
`;

export const MinMaxCell = styled.th`
  text-align: left;
`;

export const SortBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  margin: 0;
  padding: 0 2px;

  &:not(:nth-child(2)) {
    margin-left: 3px;
  }

  &:hover {
    color: green;
  }

  svg {
    width: 10px;
    height: 10px;
  }
`;

export const DurationTable = styled.table`
  border-spacing: 0;
  tbody {
    tr:last-child {
      th {
        padding-bottom: 10px;
      }
    }
  }
  th {
    border: none;
    font-size: 14px;

    label {
      display: flex;
      align-items: center;
      font-weight: 400;
    }
  }
`;

export const TableDateTime = styled.table`
  th {
    border: none;
    font-size: 12px;
  }
`;

export const StyledInput = styled.input`
  padding: 6px;
  border-radius: 2px;
  min-height: 35px;
  font-size: 15px;
`;

export const StatusCell = styled.th`
  text-align: left !important;
  color: #000;
  font-weight: 400;

  & > div {
    font-size: 13px;
    display: inline-block;
    margin: 0 auto 0 10px;
  }
`;

export const DateTimeCell = styled.th`
  border: none;
  margin-left: 10px;
  font-weight: 400;
  .form-control {
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.lightGrey2} !important;
    font-size: 13px;
    width: 65%;
  }
`;

export const MultiSelectWrapper = styled.div`
  div > button {
    padding: 6px;
    background-color: #fff;
    border-radius: 4px;
    border-width: 0;
    line-height: 1;
    border: 1px solid ${({ theme }) => theme.colors.lightGrey2} !important;
    cursor: pointer;
    box-shadow: none;
    font-size: 14px;
    height: 29px;
  }
`;
